import React from "react";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="bg-[#FEFEFE] border-t border-[rgba(20,16,13,0.1)]"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 lg:py-16">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
                    <div className="md:col-span-2">
                        <img
                            src="/cler-bau-logo.png"
                            alt="CLER BAU AG"
                            className="h-8 w-auto mb-6"
                        />
                        <p className="max-w-sm text-[14px] leading-relaxed text-[#14100D]/70">
                            Schweizer Maurerhandwerk mit Präzision, Ruhe und Anspruch.
                            Vom Plan zur soliden Realität.
                        </p>
                    </div>

                    <div>
                        <div className="text-[10px] tracking-[0.28em] uppercase text-[#E20514] mb-3">Navigation</div>
                        <ul className="space-y-2 text-[14px] text-[#14100D]/80">
                            <li><a href="/#ueber-uns" className="hover:text-[#E20514]">Über uns</a></li>
                            <li><a href="/#leistungen" className="hover:text-[#E20514]">Leistungen</a></li>
                            <li><a href="/referenzen" className="hover:text-[#E20514]">Referenzen</a></li>
                            <li><a href="/kontakt" className="hover:text-[#E20514]">Kontakt</a></li>
                        </ul>
                    </div>

                    <div>
                        <div className="text-[10px] tracking-[0.28em] uppercase text-[#E20514] mb-3">Kontakt</div>
                        <ul className="space-y-2 text-[14px] text-[#14100D]/80">
                            <li><a href="tel:+41440000000" className="hover:text-[#E20514]">+41 44 000 00 00</a></li>
                            <li><a href="mailto:info@clerbau.ch" className="hover:text-[#E20514]">info@clerbau.ch</a></li>
                            <li>Talstrasse 1<br />8852 Altendorf</li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-[rgba(20,16,13,0.08)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[12px] text-[#14100D]/50">
                    <div>© {year} CLER BAU AG · Alle Rechte vorbehalten</div>
                    <div className="flex gap-6">
                        <a href="/impressum" className="hover:text-[#E20514]">Impressum</a>
                        <a href="/datenschutz" className="hover:text-[#E20514]">Datenschutz</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
